import { axiosInstance, axiosInstanceForm } from "../../Utils/AxiosInstance";

export const GetAllWorkOrdersApi = async (projectId) => {
  try {
    // No projectId = all projects for the business.
    const query = projectId ? `?projectId=${projectId}` : "";
    const response = await axiosInstance.get(`/WorkOrders/GetAll${query}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const AddWorkOrderApi = async (data) => {
  try {
    const response = await axiosInstance.post(`/WorkOrders/Add`, data);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const UpdateWorkOrderApi = async (data) => {
  try {
    const response = await axiosInstance.put(`/WorkOrders/Update`, data);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const DeleteWorkOrderApi = async (id) => {
  try {
    const response = await axiosInstance.delete(`/WorkOrders/Delete/${id}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const GetWorkOrderByIdApi = async (id) => {
  try {
    const response = await axiosInstance.get(`/WorkOrders/GetById/${id}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const GetAllBillsApi = async (workOrderId) => {
  try {
    const response = await axiosInstance.get(`/WorkOrders/Bill/GetAll/${workOrderId}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const AddBillApi = async (data) => {
  try {
    const response = await axiosInstanceForm.post(`/WorkOrders/Bill/Add`, data);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const UpdateWOBApprovalApi = async (approvalId, status, comments) => {
  try {
    const url = `/WorkOrders/UpdateWOBApproval/${approvalId}?status=${encodeURIComponent(status)}&comments=${encodeURIComponent(comments || "")}`;
    const response = await axiosInstance.put(url);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const AddAmendmentApi = async (data) => {
  try {
    const response = await axiosInstance.post(`/WorkOrders/Amendment/Add`, data);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const ReleaseRetentionApi = async (workOrderId) => {
  try {
    const id = workOrderId?.workOrderId;
    const response = await axiosInstance.post(`/WorkOrders/Retention/Release?WorkOrderId=${id}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const AddWOPaymentApi = async (billId) => {
  try {
    const response = await axiosInstance.post(`/WorkOrders/Payment/Add?WorkOrderBillId=${billId}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};
